import { useMutation } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'

interface SendDeactivationCodeResponse {
  data: unknown
}

const sendDeactivationCode = async () => {
  const response = await authApi.post<SendDeactivationCodeResponse>(
    '/2fa/deactivate-code/send'
  )
  return response.data
}

export const useSendDeactivationCode = ({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const mutation = useMutation({
    mutationFn: sendDeactivationCode,
    onSuccess: () => {
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })

  return { mutation }
}
